import { PencilSimpleIcon } from '@c/icons';
import Button from '@ui/Button';
import { useQueryClient } from '@tanstack/react-query';
import {
  addReturnNote,
  deleteReturnNote,
} from '@util/firestore/returns/returns.service';
import { useAuth } from 'context/AuthContext';
import { TrashIcon } from 'lucide-react';
import { ReturnDocument } from 'models/returns';
import { useState } from 'react';

export default function ReturnNotes({
  returnData,
}: {
  returnData: ReturnDocument;
}) {
  const queryClient = useQueryClient();
  const { userDoc } = useAuth();
  const [newNote, setNewNote] = useState('');
  if (!userDoc?.roles?.admin && userDoc?.uid !== 'qlcEanuNfBZOpI7CmwgLN0QKPlo1')
    return null;
  return (
    <div className="my-[2.4rem] flex flex-col gap-[2.4rem]">
      <div className="flex w-full flex-col gap-[2.4rem] rounded-2xl p-[2.4rem] lg:border-[1px]">
        <div className="text-[1.8rem flex w-full justify-between gap-[0.8rem] font-semibold">
          <span>Return Notes</span>
          <Button
            text="Save"
            height="extraSmall"
            width="extraSmall"
            type="text"
            onClick={async () => {
              await addReturnNote({ id: returnData.id, note: newNote });
              queryClient.refetchQueries({
                queryKey: ['returnById', returnData.id],
              });
              setNewNote('');
            }}
            trailingIcon={<PencilSimpleIcon />}
          />
        </div>
        <div className="flex flex-col gap-[1.2rem]">
          <div className="flex w-full">
            <span className="w-[10rem] text-brand-gray">Notes</span>
            <span className="grow">
              <textarea
                className="h-[10rem] w-full rounded-lg border-[1px] border-gray-300 p-[1.2rem]"
                value={newNote}
                onChange={(e) => setNewNote(e.target.value)}
                placeholder="Add notes here..."
              ></textarea>
            </span>
          </div>
        </div>
      </div>
      {/* display all notes here */}

      {returnData.notes && returnData.notes.length > 0 && (
        <div className="flex w-full flex-col gap-[2.4rem] rounded-2xl p-[2.4rem] lg:border-[1px]">
          <div className="text-[1.8rem flex w-full justify-between gap-[0.8rem] font-semibold">
            <span>Previous Return Notes</span>
          </div>
          {returnData.notes
            .sort((a, b) => b.created - a.created)
            .map((note) => (
              <div className="flex flex-col gap-[1.2rem]" key={note?.created}>
                <div className="flex w-full justify-between">
                  <div className="flex gap-[0.8rem]">
                    <span className="w-[10rem] text-brand-gray">
                      {new Date(note?.created!).toLocaleString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: true,
                      })}
                    </span>
                    <span className="grow">{note?.text}</span>
                  </div>
                  <div className=" font-semibold text-brand-red">
                    <Button
                      text=""
                      type="text"
                      trailingIcon={<TrashIcon />}
                      onClick={async () => {
                        await deleteReturnNote({
                          id: returnData.id,
                          note,
                        });
                        queryClient.refetchQueries({
                          queryKey: ['returnById', returnData.id],
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
}
